module.exports = {"id":"5213","name":"Alessandro Gamberini","rating":"77","photo":"./data/images/photos/3/5213.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlessandroGamberini0.json
// module id = 195
// module chunks = 0